import React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Textarea } from "../../ui/textarea";
import { Alert } from "@mui/material";
import { LoadingButton } from '@mui/lab';

export const VideoUrlModal = ({ openVideoUrl, setOpenVideoUrl, handleVideoUrlSubmit, addVideoUrl, handleAddVideoUrl, videoLinkError, loading }) => {
  const isVideoLinkValid =
    addVideoUrl.videoLink.trim() !== "" &&
    /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w-]{11}.*$/.test(
      addVideoUrl.videoLink.trim()
    );

  return (
    <Dialog open={openVideoUrl} onOpenChange={() => setOpenVideoUrl(false)}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-poppins text-lg font-semibold text-gray-900">
            {addVideoUrl.latestVersion ? "Edit Video URL" : "Add Video URL"}
          </DialogTitle>
          {videoLinkError &&
            <Alert severity="error" >
              {videoLinkError}
            </Alert>
          }
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div>
            <label
              htmlFor="videoUrl"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Video URL *
            </label>
            <Input
              name="videoLink"
              type="url"
              value={addVideoUrl.videoLink}
              onChange={(e) => handleAddVideoUrl("videoLink", e.target.value)}
              error={
                addVideoUrl.videoLink !== null &&
                addVideoUrl.videoLink !== "" &&
                !/^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w-]{11}.*$/.test(
                  addVideoUrl.videoLink.trim()
                )
              }
              helperText={
                addVideoUrl.videoLink !== null &&
                  addVideoUrl.videoLink !== "" &&
                  !/^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w-]{11}.*$/.test(
                    addVideoUrl.videoLink.trim()
                  )
                  ? "Please enter a valid YouTube video link."
                  : ""
              }
              placeholder="https://youtube.com/watch?v=..."
              className="w-full"
            />
          </div>

          <div>
            <label
              htmlFor="oyeCreatorRemark"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Oye Creators Remarks (Optional)
            </label>
            <Textarea
              id="oyeCreatorRemark"
              value={addVideoUrl.oyeCreatorRemark}
              onChange={e => handleAddVideoUrl("oyeCreatorRemark", e.target.value)}
              placeholder="Add any remark about this video..."
              className="w-full min-h-[80px]"
            />
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              variant="outline"
              onClick={() => setOpenVideoUrl(false)}
              className="px-4 py-2"
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={handleVideoUrlSubmit}
              loading={loading}
              disabled={!isVideoLinkValid}
              variant="contained"
              sx={{
                backgroundColor: "#f06292",
                color: "#fff",
                '&:hover': { backgroundColor: "#e91e63" },
                px: 2,
                py: 1
              }}
            >
              {addVideoUrl.latestVersion ? "Update" : "Submit"}
            </LoadingButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
